import React from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import {
  ArrowButton, Button, Container, Content,
} from './style';

function Pagination({
  billsPerPage, totalBills, paginate, currentPage,
}: any) {
  const pageNumbers = [];
  const pageQtd = Math.ceil(totalBills / billsPerPage);

  let startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(pageQtd, startPage + 4);

  if (endPage - startPage < 4) {
    startPage = Math.max(1, endPage - 4);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const prevPage = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < pageQtd) {
      paginate(currentPage + 1);
    }
  };

  return (
    <div>
      <ul>
        <Content>
          <ArrowButton
            type="button"
            disabled={currentPage === 1}
            onClick={prevPage}
            title="Página anterior"
          >
            <MdChevronLeft size={18} />
          </ArrowButton>

          {startPage > 1 && (
            <>
              <Container>
                <Button
                  type="button"
                  onClick={() => paginate(1)}
                >
                  1
                </Button>
              </Container>
              {startPage > 2 && (
                <Container>
                  <span style={{ color: '#808099', padding: '0 4px' }}>...</span>
                </Container>
              )}
            </>
          )}

          {pageNumbers.map((number) => (
            <Container key={number}>
              <Button
                className={number === currentPage ? 'selected' : ''}
                type="button"
                onClick={() => paginate(number)}
              >
                {number}
              </Button>
            </Container>
          ))}

          {endPage < pageQtd && (
            <>
              {endPage < pageQtd - 1 && (
                <Container>
                  <span style={{ color: '#808099', padding: '0 4px' }}>...</span>
                </Container>
              )}
              <Container>
                <Button
                  type="button"
                  onClick={() => paginate(pageQtd)}
                >
                  {pageQtd}
                </Button>
              </Container>
            </>
          )}

          <ArrowButton
            type="button"
            disabled={currentPage === pageQtd}
            onClick={nextPage}
            title="Próxima página"
          >
            <MdChevronRight size={18} />
          </ArrowButton>
        </Content>
      </ul>
    </div>
  );
}

export default Pagination;
